module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/gallery3-e3d46db9841ccbeaf65149aa86f8220a.jpg";